const Textarea = ({ label, name, required, ...rest }) => {
    return <div className="flex items-start gap-2">
        <label
            htmlFor={name}
            className={`font-semibold w-64`}
        >
            {label}
            {required && <span className="text-red-600 px-1" title="Required">*</span>}
        </label>
        <textarea
            name={name}
            className={`flex-1 px-1.5 py-1 border rounded-md focus:outline-none focus:ring border-gray-200 focus:ring-sky-200 focus:border-sky-600 disabled:bg-gray-50 disabled:text-gray-400`}
            {...rest}
        />
    </div>
}

export default Textarea;